import React from "react";
import { PolicyLayout } from "./Delivery";
import { siteConfig } from "../Datas/productData";
import "../css/privacy.scss";

function Privacy() {
  return (
    <PolicyLayout
      eyebrow="Legal"
      title="Privacy policy"
      intro="This demo storefront is designed to collect only the information needed to provide a clear shopping experience."
    >
      <p className="policy-page__updated">Last updated: August 15, 2026</p>
      <section>
        <span>01</span>
        <div>
          <h2>Information we collect</h2>
          <p>When you browse, contact us or place a demonstration order, you may provide contact details, delivery information and product preferences. Cart and wishlist selections are stored locally in your browser.</p>
          <p>This frontend demonstration does not transmit or retain payment card details.</p>
        </div>
      </section>
      <section>
        <span>02</span>
        <div>
          <h2>How information is used</h2>
          <p>Information would be used to fulfil orders, provide customer support, prevent misuse, improve the store and send marketing only when a customer has chosen to receive it.</p>
        </div>
      </section>
      <section>
        <span>03</span>
        <div>
          <h2>Sharing and retention</h2>
          <p>In a production store, limited information may be shared with payment, fulfilment, analytics and delivery providers strictly to perform their services. Information should be retained only as long as needed for those purposes or required by law.</p>
        </div>
      </section>
      <section>
        <span>04</span>
        <div>
          <h2>Your choices</h2>
          <p>You may request access, correction or deletion of personal information, and may opt out of marketing at any time. Contact <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a> with a privacy request.</p>
        </div>
      </section>
    </PolicyLayout>
  );
}

export default Privacy;
